
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  getPayWalletList,
  addPayWallet,
  delPayWalletList,
} from "@/api/order/cashOrder";
import { queryAddress, setApplysig } from "@/api/product/product";
import { delObjEmptyKey } from "@/utils";
import { AppModule } from "@/store/modules/app";
import { Form as ElForm } from "element-ui";
import { getEnterprise, setEnterprise } from "@/api/universal";
import { setCollectConfig, getCollectConfig } from "@/api/order/topupOrder";

@Component({
  name: "Picsloader",
})
export default class extends Vue {
  @Prop() private attachUrl!: any;
  private editForm: any = {
    name: "",
    description: "",
  };
  private setForm: any = {
    ant_withdraw_switch: 1,
  };
  private addForm: any = {
    account_type: "",
    name: "",
  };
  private rules: any = {
    account_type: [
      {
        required: true,
        message: "Please enter the wallet type",
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: "Please enter the wallet name",
        trigger: "blur",
      },
    ],
  };
  private walletType: any = "trc20";
  private infoForm: any = {
    hidden_config: {
      trc20_payout: {
        fee_limit: "",
      },
      erc20_payout: {
        fee_limit: "",
        float_gas_level: "",
      },
    },
    google_code: "",
  };
  get language() {
    return AppModule.language;
  }

  private queryForm: any = {
    naem: "",
  };
  private listLoading: any = false;
  private list: any = [];
  private total = 0;
  private activeName: any = "1";
  // 分页器设置
  private pagesize: number = 20;
  private handleSizeChange(size) {
    this.pagesize = size;
    this.hadleGetFilesListApi();
  }

  private hashJump(row) {
    if (row.account_type === "trc20") {
      window.open(`https://tronscan.io/#/address/${row.address}`);
    } else if (row.account_type === "erc20") {
      window.open(`https://etherscan.io/address/${row.address}`);
    }
  }

  // 分页切换
  private currentPage: number = 1;
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage;
    this.hadleGetFilesListApi();
  }

  // 群列表
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true;
      let data = {
        ...this.queryForm,
      };
      delObjEmptyKey(data);
      await getPayWalletList(data).then((res: any) => {
        this.list = res;
        this.listLoading = false;
      });
    } catch (error) {
      this.listLoading = false;
    }
  }

  private async getEnterprise() {
    try {
      await getEnterprise().then((res: any) => {
        if (res.ssl_switch.ant_withdraw_switch) {
          this.setForm.ant_withdraw_switch = 1;
        } else {
          this.setForm.ant_withdraw_switch = 0;
        }
      });
    } catch (e) {
      console.log();
    }
  }

  // 自动代付
  private async testOrderNotify() {
    try {
      const data: any = {
        ssl_switch: {
          ant_withdraw_switch: this.setForm.ant_withdraw_switch,
        },
      };
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: "Operation Successfully!",
          type: "success",
        });
      });
    } catch (e) {
      console.log();
    }
  }

  @Watch("walletType", { immediate: true })
  private watchType(newVal) {
    if (this.walletType === "trc20") {
      this.infoForm.google_code = "";
      if (this.trc20Info) {
        this.infoForm.hidden_config = {
          trc20_payout: {
            fee_limit: this.trc20Info.fee_limit,
          },
        };
      } else {
        this.infoForm.hidden_config = {
          trc20_payout: {
            fee_limit: "",
          },
        };
      }
    } else {
      this.infoForm.google_code = "";
      if (this.erc20Info) {
        this.infoForm.hidden_config = {
          erc20_payout: {
            fee_limit: this.erc20Info.fee_limit,
            float_gas_level: this.erc20Info.float_gas_level,
          },
        };
      } else {
        this.infoForm.hidden_config = {
          erc20_payout: {
            fee_limit: "",
            float_gas_level: "",
          },
        };
      }
    }
  }
  private changeTabs(val: any) {
    if (val.name === "2") {
      this.getEnterprise();
      this.hadleGetFilesListApi();
    } else if (val.name === "1") {
      this.walletType = "trc20";
      this.stakeWallet();
    }
  }
  private back() {
    if (this.walletType === "trc20") {
      this.infoForm.hidden_config = {
        trc20_payout: {
          fee_limit: "",
        },
      };
    }
    if (this.walletType === "erc20") {
      this.infoForm.hidden_config = {
        erc20_payout: {
          fee_limit: "",
          float_gas_level: "",
        },
      };
    }
  }
  private loading: boolean = false;
  private async save() {
    try {
      this.loading = true;
      this.flag = true;
      if (this.walletType === "trc20") {
        delete this.infoForm.hidden_config.erc20_payout;
      } else {
        delete this.infoForm.hidden_config.trc20_payout;
      }
      const data: any = {
        ...this.infoForm,
      };
      await setCollectConfig(data).then(() => {
        this.$message({
          message: "Save successful!",
          type: "success",
        });
        this.loading = false;
        this.stakeWallet();
        this.walletType = "trc20";
        this.flagStr();
      });
    } catch (e) {
      this.loading = false;
      // this.back()
    }
  }
  private erc20Info: any = {};
  private trc20Info: any = {};
  private async stakeWallet() {
    try {
      await getCollectConfig().then((res: any) => {
        this.erc20Info = res.hidden_config.erc20_payout;
        this.trc20Info = res.hidden_config.trc20_payout;
        if (this.trc20Info.fee_limit) {
          this.infoForm.hidden_config = {
            trc20_payout: {
              fee_limit: this.trc20Info.fee_limit,
            },
          };
        }
      });
    } catch (e) {}
  }

  // 关闭弹框
  private closeAdd() {
    this.addForm = {
      name: "",
      account_type: "",
    };
    this.addSendMesVisible = false;
    this.currentPage = 1;
    this.$nextTick(() => {
      this.hadleGetFilesListApi();
    });
  }

  // 保存
  private async saveAdd() {
    (this.$refs.addForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.listLoading = true;
          const data: any = {
            ...this.addForm,
          };
          delObjEmptyKey(data);
          await addPayWallet(data).then((res: any) => {
            if (this.language === "en") {
              this.$message({
                message: "Edit successful!",
                type: "success",
              });
            }
            if (this.language === "zh_cn") {
              this.$message({
                message: "编辑成功！",
                type: "success",
              });
            }
            if (this.language === "zh_tw") {
              this.$message({
                message: "編輯成功！",
                type: "success",
              });
            }
            this.closeAdd();
            this.listLoading = false;
          });
        } catch (error) {
          this.listLoading = false;
        }
      } else {
        return false;
      }
    });
  }

  // 绑定商户
  private sendMesVisible: any = false;
  private editData: any = {};
  private edit(row) {
    this.editForm.name = row.name;
    this.editForm.description = row.description;
    this.sendMesVisible = true;
    this.editData = row;
  }

  // 新增
  private addSendMesVisible: boolean = false;
  private add() {
    this.addSendMesVisible = true;
  }

  private flag: boolean = false;
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false;
    }, 500);
  }

  // 钱包地址 查询
  private async query(row: any) {
    try {
      this.listLoading = true;
      let data: any = {
        address: row,
      };
      await queryAddress(data).then(() => {
        if (this.language === "en") {
          this.$message({
            message: "Query successfully!",
            type: "success",
          });
        } else if (this.language === "zh_cn") {
          this.$message({
            message: "查询成功!",
            type: "success",
          });
        } else if (this.language === "zh_tw") {
          this.$message({
            message: "查詢成功!",
            type: "success",
          });
        }
        this.listLoading = false;
        this.flagStr();
      });
    } catch (e) {}
    this.listLoading = false;
  }

  // 删除列表
  private del(row) {
    if (this.language === "en") {
      this.$confirm("Are you sure to delete it?", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
        callback: (action) => {
          if (action === "confirm") {
            this.delGroup(row.id);
          }
        },
      });
    }
    if (this.language === "zh_cn") {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
        callback: (action) => {
          if (action === "confirm") {
            this.delGroup(row.id);
          }
        },
      });
    }
    if (this.language === "zh_tw") {
      this.$confirm("確定刪除嗎？", {
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        type: "warning",
        callback: (action) => {
          if (action === "confirm") {
            this.delGroup(row.id);
          }
        },
      });
    }
  }
  // 删除
  private async delGroup(id) {
    try {
      this.listLoading = true;
      const params: any = {
        id: id,
      };
      await delPayWalletList(params).then((res: any) => {
        if (this.language === "en") {
          this.$message({
            message: "Delete successful!",
            type: "success",
          });
        }
        if (this.language === "zh_cn") {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
        }
        if (this.language === "zh_tw") {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
        }
        this.hadleGetFilesListApi();
        this.listLoading = false;
      });
    } catch (error) {
      this.listLoading = false;
    }
  }

  private reset() {
    this.currentPage = 1;
    this.queryForm = {
      name: "",
    };
    this.$nextTick(() => {
      this.hadleGetFilesListApi();
    });
  }

  private select() {
    this.currentPage = 1;
    this.hadleGetFilesListApi();
  }

  // 申请多签
  private async applySig(row: any) {
    let data: any = {
      wallet_address: row.address,
    };
    await setApplysig(data).then(() => {
      if (this.language === "en") {
        this.$message({
          message: "Operation successfully!",
          type: "success",
        });
      } else if (this.language === "zh_cn") {
        this.$message({
          message: "操作成功!",
          type: "success",
        });
      } else if (this.language === "zh_tw") {
        this.$message({
          message: "操作成功!",
          type: "success",
        });
      }
      this.hadleGetFilesListApi();
    });
  }

  mounted() {
    this.stakeWallet();
  }

  created() {}
}
